import React from 'react';
import { Settings } from 'lucide-react';

const CookieSettings = () => {
    const openSettings = () => {
        if (typeof window !== 'undefined' && window.openCookieSettings) {
            window.openCookieSettings();
        }
    };

    return (
        <a 
            onClick={openSettings}
            className="text-secondary text-decoration-none small d-inline-flex align-items-center cursor-pointer"
            aria-label="Ouvrir les paramètres des cookies"
            // href="javascript:void(0)"
        >
            <Settings size={14} className="me-1" />
            Paramètres des cookies
        </a>
    );
};

export default CookieSettings;